/**
 * A count for a capsule. Anything past `maxCount` reads as `99+`: a capsule is
 * a glance at a size, and a six-figure queue drawn in full stretches the row
 * it sits in out of shape.
 */
export function formatCount(
  count: number,
  maxCount: number | undefined,
): string {
  return maxCount !== undefined && count > maxCount
    ? `${maxCount.toLocaleString()}+`
    : count.toLocaleString();
}
